import { gql } from '@apollo/client';

/**
 * Submit a sales inquiry from the WNC website.
 * This is a public mutation - no authentication required.
 * Region is appended to message for WNC lead tracking.
 */
export const SUBMIT_SALES_LEAD = gql`
  mutation SubmitSalesLead($input: SalesLeadInput!) {
    submitSalesLead(input: $input) {
      success
      message
    }
  }
`;

export interface SalesLeadInput {
  businessName: string;
  contactName: string;
  email: string;
  phone?: string;
  expectedSize?: string;
  message?: string;
}

export interface SalesLeadResult {
  success: boolean;
  message?: string;
}

export interface SubmitSalesLeadResponse {
  submitSalesLead: SalesLeadResult;
}
